import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ApiService } from 'app/main/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AcceptanceService implements Resolve<any> {

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (state.url.includes('faq')) {
      try {
        const resolved: any = {};
        const res: any = await this.retrieveFAQByFilterPaged('', 0, 10).catch((err) => {
          console.error(err);
          resolved.data = {
            list: [],
            count: 0
          };
        });
        if (res) {
          if (res.ok) {
            resolved.data = {
              list: res.payload,
              count: res.payload.length
            };
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }

    } else if (state.url.includes('privacy')) {
      try {
        const resolved: any = {};
        const res: any = await this.retrievePrivacyByFilterPaged('', 0, 10).catch((err) => {
          console.error(err);
          resolved.data = {
            list: [],
            count: 0
          };
        });
        if (res) {
          if (res.ok) {
            resolved.data = {
              list: res.payload,
              count: res.payload.length
            };
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    } else if (state.url.includes('termini')) {
      try {
        const resolved: any = {};
        const res: any = await this.retrieveTermsByFilterPaged('', 0, 10).catch((err) => {
          console.error(err);
          resolved.data = {
            list: [],
            count: 0
          };
        });
        if (res) {
          if (res.ok) {
            resolved.data = {
              list: res.payload,
              count: res.payload.length
            };
          }
        }
        return resolved;
      } catch (err) {
        this.router.navigateByUrl(``);
      }
    }
  }

  constructor(
    private api: ApiService,
    private router: Router
  ) {
  }

  async retrieveFAQByFilterPaged(filterValue, pageIndex, pageSize) {
    return await this.api.getRequestPromise(`documents/faq?filterString=${filterValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async uploadFAQ(multipart) {
    return await this.api.postFileRequestPromise(`documents/faq/upload`, multipart);
  }

  async activateFAQ(documentId) {
    return await this.api.putRequestPromise(`documents/faq/${documentId}/activate`, {});
  }

  async retrievePrivacyByFilterPaged(filterValue, pageIndex, pageSize) {
    return await this.api.getRequestPromise(`documents/privacyAndCookies?filterString=${filterValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async uploadPrivacy(multipart) {
    return await this.api.postFileRequestPromise(`documents/privacyAndCookies/upload`, multipart);
  }

  async activatePrivacy(documentId) {
    return await this.api.putRequestPromise(`documents/privacyAndCookies/${documentId}/activate`, {});
  }

  async retrieveTermsByFilterPaged(filterValue, pageIndex, pageSize) {
    return await this.api.getRequestPromise(`documents/termsAndConditions?filterString=${filterValue}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  }

  async uploadTerms(multipart) {
    return await this.api.postFileRequestPromise(`documents/termsAndConditions/upload`, multipart);
  }

  async activateTerms(documentId) {
    return await this.api.putRequestPromise(`documents/termsAndConditions/${documentId}/activate`, {});
  }

  async acceptances(userInfoId, body) {
    return await this.api.postRequestPromise(`users/${userInfoId}/acceptances`, body);
  }

  async myAcceptances(body) {
    return await this.api.postRequestPromise(`users/acceptances`, body);
  }

  async downloadDocument(fileId, nameToShow) {
    return await this.api.downloadFile(`documents/${fileId}/download`, nameToShow);
  }

  async downloadTheActivePrivacyAndCookies() {
    return await this.api.downloadFile(`public/privacyAndCookies/theActive/download`, 'privacyAndCookies.pdf');
  }

  async downloadTheActiveTermsAndConditions() {
    return await this.api.downloadFile(`public/termsAndConditions/theActive/download`, 'termsAndConditions.pdf');
  }

}
